import React from 'react';
import { FaInfoCircle as FaInfoIcon } from 'react-icons/fa';

const FaInfoCircle: React.FC<{ style?: React.CSSProperties; className?: string }> = (props) => (
  <FaInfoIcon {...props} />
);

export default FaInfoCircle;
